import React from 'react';
import {Home, BookOpen, Monitor, RotateCcw, User} from 'lucide-react';
export default function BottomNavigation({currentPage,setCurrentPage}) {
  const items=[['home','홈',Home],['library','자료',BookOpen],['online_test','학습',Monitor],['review','복습',RotateCcw],['dashboard','내 학습',User]];
  return <nav className="bb-bottom-nav bb-ui" aria-label="모바일 주요 메뉴"><div>{items.map(([page,label,Icon])=><button key={page} onClick={()=>setCurrentPage(page)} aria-current={currentPage===page?'page':undefined}><Icon size={20} strokeWidth={currentPage===page?2:1.6}/><span>{label}</span></button>)}</div></nav>;
}
